import React from "react";

import { Container } from "./styles";

export default function Banner({ text, img }) {
	return (
		<Container image={img}>
			<button onClick={() => window.history.back()}>
				<img
					src={require("@/assets/img/back.png").default}
					alt='icone voltar'
					loading='lazy'
				/>
			</button>
			<h1>
				<span>Programa Fidelidade GERIOOX</span>
				{text}
			</h1>
		</Container>
	);
}
